import axiosInstance from '@/plugins/axios';

// Config de coleta automática por empresa × certidão (Empresas → Coleta automática de dados).
// Config-mãe das 5 coletas; BFF agnes-compliance-api (/collection-config).
export default class ServiceColetaConfig {
  static obter = (rootCnpj) => axiosInstance.get(`collection-config/${rootCnpj}`);

  static salvar = (rootCnpj, configs) =>
    axiosInstance.put(`collection-config/${rootCnpj}`, { configs });

  static historico = (rootCnpj) => axiosInstance.get(`collection-config/${rootCnpj}/history`);

  static coletarAgora = (rootCnpj, certidao) =>
    axiosInstance.post(`collection-config/${rootCnpj}/coletar-agora`, { certidao });
}

// ordem + rótulos das certidões cobertas
// ECAC_MESSAGES = Caixa Postal e-CAC, coletada via ic/consultar (SERPRO) e persistida
// (ver PageMensagensEcac.tsx) — reintroduzido em 2026-08-13 apontando pra rota certa
// (a antiga rota de intimações foi removida por não ser a fonte real).
export const CERTIDOES = ['CRF', 'CND', 'DCTF', 'ECAC_MESSAGES', 'CNDT'];

export const CERTIDAO_LABEL = {
  CRF: 'CRF',
  CND: 'Certidão Federal',
  DCTF: 'DCTF',
  ECAC_MESSAGES: 'Mensagens e-CAC',
  CNDT: 'CNDT',
};

// periodicidade = nova regra de produto (enum fechado)
export const PERIODICIDADES = [
  { value: 'MENSAL', label: 'Mensal' },
  { value: 'SEMESTRAL', label: 'Semestral' },
  { value: 'DIARIO', label: 'Diário' },
];
export const PERIODICIDADE_LABEL = { MENSAL: 'Mensal', SEMESTRAL: 'Semestral', DIARIO: 'Diário' };
